import { apiClient, getActivePvzId } from './_shared.js'

// ============================================
// CHAT
// ============================================

export async function getChatTopics() {
  const pvzId = getActivePvzId()
  if (!pvzId) return []
  return await apiClient(`/chat/topics?pvzId=${pvzId}`)
}

export async function getChatMessages(topicId) {
  const data = await apiClient(`/chat/messages/${topicId}`)
  return data.map(msg => ({
    ...msg,
    attachments: typeof msg.attachments === 'string' ? JSON.parse(msg.attachments) : msg.attachments
  }))
}

export async function uploadChatAttachment(file) {
  const formData = new FormData()
  formData.append('file', file)
  
  const API_URL = import.meta.env.VITE_API_URL || '/api';
  const token = localStorage.getItem('token')
  
  const res = await fetch(`${API_URL}/upload/attachment`, {
    method: 'POST',
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    },
    body: formData
  })
  
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}))
    throw new Error(errorData.error || 'Ошибка загрузки файла')
  }
  
  return await res.json()
}

export async function sendChatMessage(topicId, content, authorId, attachments = [], replyTo = null) {
  const pvzId = getActivePvzId()
  const data = await apiClient('/chat/messages', {
    method: 'POST',
    body: JSON.stringify({ pvz_id: pvzId, topic_id: topicId, content, author_id: authorId, attachments, reply_to: replyTo })
  })
  if (!data) throw new Error('Ошибка отправки сообщения')
  return data
}

export async function createChatTopic(name, description, isPrivate = false, createdBy, participantIds = null) {
  const pvzId = getActivePvzId()
  return await apiClient('/chat/topics', {
    method: 'POST',
    body: JSON.stringify({ pvz_id: pvzId, name, description, is_private: isPrivate, created_by: createdBy, participant_ids: participantIds })
  })
}

export async function updateChatTopic(topicId, name, description, isPrivate, participantIds) {
  return await apiClient(`/chat/topics/${topicId}`, {
    method: 'PUT',
    body: JSON.stringify({ name, description, is_private: isPrivate, participant_ids: participantIds })
  })
}

export async function deleteChatTopic(topicId) {
  return await apiClient(`/chat/topics/${topicId}`, {
    method: 'DELETE'
  })
}

/**
 * Переключить реакцию на сообщение.
 * reactions хранится как JSONB: { "👍": ["userId1", "userId2"], "❤️": ["userId3"] }
 */
export async function toggleMessageReaction(messageId, emoji, userId, table = 'chat_messages') {
  if (table === 'chat_messages') {
    return await apiClient(`/chat/messages/${messageId}/reaction`, {
      method: 'POST',
      body: JSON.stringify({ emoji, userId })
    })
  } else {
    return await apiClient(`/direct-chat/messages/${messageId}/reaction`, {
      method: 'POST',
      body: JSON.stringify({ emoji, userId })
    })
  }
}

export async function updateChatMessage(id, content) {
  return await apiClient(`/chat/messages/${id}`, {
    method: 'PUT',
    body: JSON.stringify({ content })
  })
}

export async function deleteChatMessage(id) {
  return await apiClient(`/chat/messages/${id}`, {
    method: 'DELETE'
  })
}

export async function markMessagesRead(topicId, userId) {
  return await apiClient('/chat/mark-read', {
    method: 'POST',
    body: JSON.stringify({ topicId, userId })
  })
}

// Получить количество непрочитанных по каждой теме
export async function getUnreadCounts(userId) {
  const pvzId = getActivePvzId()
  try {
    const data = await apiClient(`/chat/all-unread?userId=${userId}&pvzId=${pvzId}`)
    return data || { counts: {}, lastUnreadMessage: null }
  } catch(e) {
    return { counts: {}, lastUnreadMessage: null }
  }
}
